import { ref } from 'vue'
import type { AdminError } from './AdminErrorToasts.vue'

export function useAdminErrors() {
  const errors = ref<AdminError[]>([])
  let nextId = 0

  function notifyError(title: string, error: unknown) {
    errors.value = [...errors.value, { id: nextId++, title, content: error instanceof Error ? error.message : String(error ?? '') }]
  }

  function dismissError(id: number) {
    errors.value = errors.value.filter(error => error.id !== id)
  }

  return { errors, notifyError, dismissError }
}
